module.exports = __webpack_public_path__ + "static/media/mcqst.78da401c.png";